export default __webpack_public_path__ + "static/media/step5.f47f63c1.png";